<template>
  <!-- modal de filtro de gestor documental -->
  <div>

    <div v-if="withButton"
      class="mr-2 rounded-sm" @click="show()">
      <v-button icon="project-diagram" class="mr-4"><span class="hidden sm:inline">{{ $t('filters') }}</span></v-button>
    </div>

    <b-modal :active.sync="isModalActive" has-modal-card >

      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
          <!-- Modal header -->
          <div class="flex items-start justify-between p-3 border-b- rounded-t">
              <h3 class="text-xl font-semibold text-gray-900">
                {{ $t('filters') }}
              </h3>
          </div>

          <!-- Modal body: campos de filtro (antes en folders-filters-fields) -->
          <div class="p-3 space-y-6">
            <div class="flex w-full flex-col items-center mb-4">

              <!-- por nombre -->
              <div class="w-full">
                <b-field :label="$t('search_by_name')">
                  <b-input
                    v-model="filterName"
                    :placeholder="$t('name')"
                    type="search"
                    icon="search"
                    icon-pack="fas">
                  </b-input>
                </b-field>
              </div>

              <!-- por emplazamiento -->
              <div class="w-full">
                <b-field :label="$t('search_by_location')">
                  <b-select
                    v-model="filterLocation"
                    :placeholder="$t('select')"
                    icon="search"
                    icon-pack="fas"
                    expanded
                  >
                    <option :value="null">{{$t('select')}}</option>
                    <option v-for="flowOption in locationsList" :value="flowOption.id" :key="'location_'+flowOption.id">
                      {{ flowOption.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <!-- mostrar actividades cerradas -->
              <div class="w-full pt-2">
                <b-switch v-model="filterShowClosed">
                  {{ $t('show_closed_activites') }}
                </b-switch>
              </div>

            </div>
          </div>

          <!-- Modal footer -->
          <div class="flex items-center justify-end p-3 space-x-2 border-t- border-gray-200 rounded-b">
            <b-button @click="clearFilter()">{{ $t('clean_filters') }}</b-button>
            <b-button type="is-info"
              @click="applyFilter()">Aplicar filtros</b-button>
          </div>
      </div>

      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </b-modal>

  </div>
</template>

<script>
export default {
  name: "folders-filters-modal",

  props: {
    withButton: { type: Boolean, default: true },
    locationsList: { type: Array, default() { return [] } }
  },

  data: () => ({
    isModalActive: false,
    isLoading: false,
    filterName: '',
    filterLocation: null,
    filterShowClosed: false, // incluir actividades cerradas
    filters: {}, // ultimos filtros aplicados (expuestos vía getFilters)
  }),

  methods: {
    show() {
      this.isModalActive = true
    },

    // Construye el objeto de filtros a emitir/consultar
    generateFilters() {
      const params = {};
      if (this.filterName.length >= 3) {
        params.n = this.filterName;
      }
      if (this.filterLocation !== null) {
        params.location_id = this.filterLocation;
      }
      if (this.filterShowClosed) {
        params.filterShowClosed = this.filterShowClosed;
      }
      return params;
    },

    // Reset de los campos internos
    cleanFilters() {
      this.filterName = '';
      this.filterLocation = null;
      this.filterShowClosed = false;
    },

    applyFilter() {
      this.filters = this.generateFilters();
      this.$emit('epc-apply-filters', this.filters);
      this.isModalActive = false;
    },

    clearFilter() {
      this.cleanFilters();
      this.filters = this.generateFilters();
      this.$emit('epc-apply-filters', this.filters);
      this.isModalActive = false;
    },

    // Permite a componentes padres leer los filtros actuales sin reabrir el modal
    getFilters() {
      return this.filters;
    }
  }
};
</script>

<style scoped>

</style>
